import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const KidAndFamilyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "KidAndFamilyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M5.43452 9.31426C6.62587 9.31426 7.59165 8.34848 7.59165 7.15713C7.59165 5.96578 6.62587 5 5.43452 5C4.24317 5 3.27739 5.96578 3.27739 7.15713C3.27739 8.34848 4.24317 9.31426 5.43452 9.31426Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.7611 10.2169C18.9524 10.2169 19.9182 9.25113 19.9182 8.05978C19.9182 6.86843 18.9524 5.90265 17.7611 5.90265C16.5697 5.90265 15.604 6.86843 15.604 8.05978C15.604 9.25113 16.5697 10.2169 17.7611 10.2169Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.5907 12.8634C12.7821 12.8634 13.7479 11.8976 13.7479 10.7063C13.7479 9.51492 12.7821 8.54914 11.5907 8.54914C10.3994 8.54914 9.4336 9.51492 9.4336 10.7063C9.4336 11.8976 10.3994 12.8634 11.5907 12.8634Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.02549 16.1954C8.37083 14.8257 8.83686 13.8797 8.86432 13.8217L8.86526 13.8193H8.86901V12.1887C8.86901 11.1292 8.01004 10.2701 6.95035 10.2701H3.91866C2.85903 10.2701 2 11.1292 2 12.1887V18.5106H7.67335C7.7165 17.6728 7.85287 16.88 8.02549 16.1954Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.4831 16.1954C13.8284 14.8257 14.2944 13.8797 14.3219 13.8217L14.3228 13.8193H8.87118C8.87282 13.8228 8.88324 13.8453 8.90198 13.8849C8.9384 13.9624 9.00398 14.1069 9.08636 14.3069C9.40342 15.0779 9.96348 16.6811 10.0572 18.5106H13.1309C13.174 17.6728 13.3105 16.88 13.4831 16.1954Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.1956 13.1143C21.1956 12.0545 20.3366 11.1957 19.2769 11.1957H16.2452C15.1856 11.1957 14.3266 12.0545 14.3266 13.1143V13.8193H14.3287C14.3304 13.8228 14.3408 13.8453 14.3595 13.8849C14.396 13.9624 14.4615 14.1069 14.5439 14.3069C14.861 15.0779 15.421 16.6811 15.5147 18.5106H22L21.1956 13.1143Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default KidAndFamilyIcon;
